import { get } from './https';

export interface ProductListItem {
  _id: string;
  productId?: string;
  name: string;
  brand?: string;
  model?: string;
  image?: string;
  images?: string[];
}

export interface ProductDetail {
  _id: string;
  productId: string;
  name: string;
  description?: string;
  images: string[];
  category: string;
  subCategory?: string;
  sku?: string;
  brand?: string;
  model?: string;
  offerLabel?: string;
  yearOfMfg?: number;
  countryOfOrigin?: string;
  featured?: boolean;
  active?: boolean;

  pricing?: {
    mrp?: number;
    discountedPrice?: number;
    customerPrice?: number;
    contractorPointPrice?: number;
    discountedPercentage?: number;
  };

  stock?: number;

  specifications?: {
    acType?: string;
    tonnage?: string;
    inverter?: boolean;
    starRating?: number;

    iseer?: string;
    powerConsumption?: string;
    powerRequirement?: string;
    powerSupply?: string;
    ratedCurrent?: string;

    coolingCapacity?: string;
    compressorType?: string;
    refrigerant?: string;
    ambientTemperature?: string;
    convertibleMode?: string;
    condenserCoil?: string;
    coverageArea?: string;

    airFlowDirection?: string;
    airFlowVolume?: string;
    dustFilter?: string;
    antiBacteria?: string;

    indoorUnitDimensions?: string;
    outdoorUnitDimensions?: string;
    indoorUnitWeight?: string;
    outdoorUnitWeight?: string;
    bodyMaterial?: string;
    color?: string;

    communicationCableSize?: string;
    connectingPipeLength?: string;
    copperPipeSize?: string;
    copperKit?: string;

    remoteControl?: string;
    sleepMode?: string;
    autoRestart?: string;
    selfDiagnosis?: string;
    timer?: string;
    display?: string;
    wifiConnectivity?: string;

    noiseLevel?: string;
    quietMode?: string;

    specialFeatures?: string[];
    manufacturingYear?: string;

    warranty?: {
      product?: string;
      compressor?: string;
      pcb?: string;
    };
  };
}

// Admin: search shop products (used by the comparison picker)
const GETProducts = async ({
  search = '',
  category,
  page = 1,
  limit = 25,
}: {
  search?: string;
  category?: string;
  page?: number;
  limit?: number;
}): Promise<ProductListItem[]> => {
  const response = await get('/api/v1/admin/shop/product-list', {
    params: { page, limit, search, ...(category ? { category } : {}) },
  });
  if (response?.status === 200 && response?.data?.status) {
    return response.data.data || [];
  }
  throw new Error(response?.data?.message || 'Failed to fetch products');
};

// Admin: full product document including all specifications
const GETProductById = async (productId: string): Promise<ProductDetail> => {
  if (!productId) {
    throw new Error('Product id is required');
  }
  const response = await get(`/api/v1/admin/shop/product/${productId}`);
  if (response?.status === 200 && response?.data?.status) {
    return response.data.data;
  }
  throw new Error(response?.data?.message || 'Failed to fetch product');
};

export { GETProducts, GETProductById };
